import React from 'react';

import { InfoBox } from '@infoods/lifebase-ui';
import classes from './WorkoutMeals.module.scss';
import { MealRow } from './MealRow/MealRow';
import { HeaderRow } from './HeaderRow/HeaderRow';

const WorkoutMeals = () => {
  return (
    <InfoBox title="Pre/Post Workouts" customContentPadding>
      <div className={classes.mealTable}>
        <HeaderRow />
        <MealRow title="Pre Workout" mealFromKey="preWorkout" />
        <MealRow title="Post Workout" mealFromKey="postWorkout" />
      </div>
    </InfoBox>
  );
};

export { WorkoutMeals };
